import { getAgentForm } from '../../../selectors/biasharaFlexi/travelAgentModal';
import { getBiasharaFlexiCoverDetailsForm, getBiasharaFlexiCoverDetailsReferenceData } from '../../../selectors/biasharaFlexi/coverDetails';
import { getAccessToken } from '../../../selectors/biasharaFlexi/payment';
import { getIsApiPending } from '../../../selectors/biasharaFlexi/payloadCollection';
import { apiTransitionPayloadCollection } from '../../../actions/biasharaFlexi/payloadCollection';
import { setCompanyIdValue, setQuoteIdValue } from '../../../actions/biasharaFlexi/companyDetails';
import axios from 'axios';

export const saveQuoteDetails = (store, next, action) => { 
    (async() => {
        if (!getIsApiPending(store.getState())) {
            store.dispatch(apiTransitionPayloadCollection.pending());
            try {
                const resp = await makeSubmission(store.getState());

                if (resp.data) {
                    store.dispatch(setCompanyIdValue(resp.data.data.companyDetails.id))
                    store.dispatch(setQuoteIdValue(resp.data.data.quotation.id))
                    store.dispatch(apiTransitionPayloadCollection.initial());
                }
            } catch (e) {
                console.error(e);
                store.dispatch(apiTransitionPayloadCollection.initial());
            }
        }
    })();
    return next(action);
}

const payloadCollection = (state) => {

    const agent = getAgentForm(state);
    const premium = getBiasharaFlexiCoverDetailsReferenceData(state);
    const quotation = getBiasharaFlexiCoverDetailsForm(state);

    const payload = {
        premium: premium.annual_premium || 'N/A',
        totalEmployees: quotation.employeesNumber.value,
        benefitAmount: quotation.benefitAmount.label.split(',').join(''),
        bandOption: quotation.benefitAmount.value,
        countryCode: "KE",
        agentCode: agent.agentCode.value || 'N/A',
        referredByAgent: agent.intermediaryType.value === 'AGENTS' ? 'true' : 'false' || 'N/A',
    }

    return {
        ...payload
    }
}

const makeSubmission = async (state) => {
    const loginData = getAccessToken(state);
    try {
        const url = '/om-api/biashara-flexi/save-quote';
        return await axios.post(url, payloadCollection(state), {
            headers: {
                'Content-Type': 'application/json',
                accessToken: loginData.accessToken,
            },
        });
    } catch (e) {
        throw e;
    }
};
